<div class="body">
  <br />
  <tr>

    <td class="col-md-1" style="vertical-align: top;">
      Calidad Jurídica  
    </td>
    <td class="col-md-2">
      <input id="grado" name="grado" class="form-control" [disabled]="afiliado.deshabilitado" [(ngModel)]="afiliado.calidadJuridica" type="text" 
        placeholder="Calidad Juridica." />
    </td>

    <td class="col-md-1" style="vertical-align: top;">
      Fecha Calidad Jurídica
    </td>
    <td class="col-md-2">
      <input id="grado" name="grado" class="form-control" [disabled]="afiliado.deshabilitado" [(ngModel)]="afiliado.fechaCalidadJuridica" matInput
        type="date"  placeholder="fecha Calidad Juridica." />
    </td>
  </tr>
 

  <tr>
    <td class="col-md-1 col-2" style="vertical-align: top;">
      Programa Presupuestario
    </td>
    <td class="col-md-2">
      <input id="grado" name="grado" class="form-control" [disabled]="afiliado.deshabilitado" [(ngModel)]="afiliado.programaPresupuestario" type="text"
         placeholder="programa Presupuestario." />
    </td>
    <td class="col-md-1" style="vertical-align: top;">
    </td>
    <td class="col-md-2">
    </td>
  </tr>
  

  <tr>
    <td class="col-md-1 col-2" style="vertical-align: top;">
      <label >Grado </label> 
    </td>
    <td class="col-md-2">
      <input id="grado" name="grado" class="form-control" [disabled]="afiliado.deshabilitado" [(ngModel)]="afiliado.grado" type="text" 
        placeholder="Grado del afiliado." />
    </td>
    <td class="col-md-1" style="vertical-align: top;">
      Fecha inicio Grado
    </td>
    <td class="col-md-2">
      <input id="fechaInicioGrado" name="fechaInicioGrado" [disabled]="afiliado.deshabilitado" class="form-control" [(ngModel)]="afiliado.fechaInicioGrado"
        matInput type="date"  placeholder="fecha inicio del grado." />
    </td>
  </tr>
  

  <tr>
    <td class="col-md-1 col-2" style="vertical-align: top;">
      <label >Estamento</label>
      
    </td>
    <td class="col-md-2">
      <input id="Estamento" name="Estamento" [disabled]="afiliado.deshabilitado" class="form-control" [(ngModel)]="afiliado.estamento" type="text" 
        placeholder="estamento del afiliado." />
    </td>

    <td class="col-md-1" style="vertical-align: top;">
      Fecha Cargo
    </td>
    <td class="col-md-2">
      <input id="fechaCargo" name="fechaCargo" [disabled]="afiliado.deshabilitado" class="form-control" [(ngModel)]="afiliado.fechaCargo" matInput
        type="date"  placeholder="fecha cargo." />
    </td>
  </tr>
  

  <tr>
    <td class="col-md-1 col-2" style="vertical-align: top;">
      <label >N° de Resolución</label> 
    </td>
    <td class="col-md-2">
      <input id="numResolucion" name="numResolucion" [disabled]="afiliado.deshabilitado" class="form-control" [(ngModel)]="afiliado.numResolucion"
        type="text"  placeholder="número Resolución." />
    </td>

    <td class="col-md-1" style="vertical-align: top;">
      Fecha Resolución
    </td>
    <td class="col-md-2">
      <input id="fechaResolucion" name="fechaResolucion" [disabled]="afiliado.deshabilitado" class="form-control" [(ngModel)]="afiliado.fechaResolucion"
        matInput type="date"  placeholder="fecha Resolucion." />
    </td>
  </tr>
 


  <tr>
    <td class="col-md-1 col-2" style="vertical-align: top;">
      <label >Asociado a</label>  
    </td>
    <td class="col-md-2">
      <input id="asociadoA" name="asociadoA" class="form-control" [disabled]="afiliado.deshabilitado" [(ngModel)]="afiliado.asociadoA" type="text" 
        placeholder="asociado A." />
    </td>
    <td class="col-md-1" style="vertical-align: top;">
    </td>
    <td class="col-md-2">
    </td>
  </tr>
  



  <tr>
    <td class="col-md-1" style="vertical-align: top;">
      funcion Realizada
    </td>
    <td class="col-md-2">
      <input id="funcionRealizada" name="funcionRealizada" [disabled]="afiliado.deshabilitado" class="form-control" [(ngModel)]="afiliado.funcionRealizada"
        type="text"  placeholder="función Realizada." />
    </td>
    <td class="col-md-1" style="vertical-align: top;">
    </td>
    <td class="col-md-2">
    </td>
  </tr>
  


  <!--/form-->
</div>